import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Image from 'components/Common/Image/Image'
import LineLuxuryEscapesMonogramIcon from 'LuxKit/Icons/line/LineLuxuryEscapesMonogramIcon'

const BACKGROUND_IMAGE_IDS = [
  'ug4tob1vwqy2wy7lu08c',
  'j6awaoj85focmvct1nnu',
  'ikdsdj7afstj03xqz2jr',
  'mcgnbxdcikgz60ni7evj',
  'fqlnlei5o93e83o13cpn',
  '4ktyrsdowy8tgii8ynb',
] as const

const SPINNER_GIF_ID = '9di083lpb7er92jbjmtj'

function getBackgroundImageId(itemId: number): string {
  const index = Math.abs(itemId) % BACKGROUND_IMAGE_IDS.length
  return BACKGROUND_IMAGE_IDS[index]
}

const Container = styled.div`
  position: relative;
  width: ${rem(136)};
  height: ${rem(136)};
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
`

const BackgroundImage = styled(Image)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(12px);
`

const CenteredContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem(26)};
  height: ${rem(26)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: ${props => props.theme.shadow.bottom.small};
`

const SpinnerGif = styled(Image)`
  position: absolute;
  width: ${rem(56)};
  height: ${rem(56)};
`

interface Props {
  className?: string
  itemId: number
}

function PlaceImageLoader({ className, itemId }: Props) {
  const intl = useIntl()
  const backgroundImageId = getBackgroundImageId(itemId)

  return (
    <Container className={className}>
      <BackgroundImage
        id={backgroundImageId}
        fit="center"
        width={136}
        height={136}
        quality="eco"
        alt=""
      />
      <Overlay>
        <CenteredContent>
          <LogoContainer>
            <LineLuxuryEscapesMonogramIcon size="XS" />
          </LogoContainer>
          <SpinnerGif
            id={SPINNER_GIF_ID}
            enhancedFormats={false}
            width={56}
            height={56}
            disableBlur
            alt={intl.formatMessage({
              id: 'v3z33PtKiw4IaL9b6hIW',
              defaultMessage: 'Loading',
              description: 'Alt text for the loading spinner animation in the trip planner chat',
            })}
          />
        </CenteredContent>
      </Overlay>
    </Container>
  )
}

export default memo(PlaceImageLoader)
